import { Navigate } from "react-router-dom";

import {
    AdminLayout,
    AdminProjects,
    Dashboard,
    Users,
    ItSupport,
    ItSupportDetails,
    Biometric,
    BiometricDetails,
    UserDetails,
    ContentDetails,
    Masters,
    MasterDetails,
    Login,
    Content,
    ContentConfiguration,
    ContentPreview,
    EnableExam,
    ScoreManagement,
    CustomerDashboard,
    CustomerMockExam,
    CustomerLiveExam,
    CustomerChart,
    UploadLayout,
    FeedbackPreview,
    ContentDashboardLayout,
    Documents,
    UpdateTime,
    MacIds,
    ChangePassword,
    ResetPassword,
    DescriptiveContentPreview,
    FeedbackUpload,
    ViewContentConfiguration,
    Candidates,
    ExamSummary,
    ServerSummary,
    Reports,
} from "../Modules/Admin";
// import { Login } from "../Modules/Shared";
import AdminAuthGuard from './AdminAuthGuard';
import ContentAdminGuard from './ContentAdminGuard';
import BackOfficeAuthGuard from "./BackOfficeAuthGuard";
import { InstructionsUpload } from "../Modules/Admin/Components/InstructionsUpload/InstructionsUpload";
import CustomerAuthGuard from "./CustomerAuthGuard";
// import AdminProjectGuard from "./AdminProjectGuard";


export const AdminRoutes = [
    // {
    //     path: '/project',
    //     element: <Navigate to='/project/project' />
    // },
    {
        path: ':projectName',
        element: <AdminLayout />,
        children: [
            {
                path: '',
                element: <AdminProjects />,
            },
            {
                path: 'login',
                element: <Login />
            },
            {
                path: 'reset-password',
                element: <ResetPassword />
            },
            {
                path: 'change-password',
                element: <ChangePassword />
            },
            // {
            //     path: 'menu-options',
            //     element: <AdminAuthGuard allowedTypes={[2]} component={<MenuOptions />} />
            // },
            {
                path: 'dashboard',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<Dashboard />} />
            },
            {
                path: 'exam-summary',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<ExamSummary />} />
            },
            {
                path: 'server-summary',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<ServerSummary />} />
            },
            {
                path: 'masters',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Masters />} />
            },
            {
                path: 'masters/master-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<MasterDetails />} />
            },
            {
                path: 'candidates',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Candidates />} />
            },
            {
                path: 'users',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Users />} />
            },
            {
                path: 'users/user-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<UserDetails />} />
            },
            {
                path: 'content',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Content />} />
            },
            {
                path: 'content/content-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ContentDetails />} />
            },
            {
                path: 'it-support',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ItSupport />} />
            },
            {
                path: 'it-support/it-support-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ItSupportDetails />} />
            },
            {
                path: 'biometric',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Biometric />} />
            },
            {
                path: 'biometric/biometric-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<BiometricDetails />} />
            },
            {
                path: 'documents',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Documents />} />
            },
            {
                path: 'update-time',
                element: <AdminAuthGuard allowedTypes={[2]} component={<UpdateTime />} />
            },
            {
                path: 'mac-ids',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[102]} component={<MacIds />} />
            },
            {
                path: 'reports',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[103]} component={<Reports />} />
            },
            {
                path: 'content-dashboard',
                element: <ContentDashboardLayout />
            },
            {
                path: 'content-configuration',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ContentConfiguration />} />
            },
            {
                path: 'feedback-upload',
                element: <AdminAuthGuard allowedTypes={[2]} component={<FeedbackUpload />} />
            },
            {
                path: 'feedback-preview',
                element: <AdminAuthGuard allowedTypes={[2]} component={<FeedbackPreview />} />
            },
            {
                path: 'instructions-upload',
                element: <AdminAuthGuard allowedTypes={[2]} component={<InstructionsUpload />} />
            },
            {
                path: 'upload',
                children: [
                    {
                        path: '',
                        element: <UploadLayout />
                    },
                    {
                        path: 'view-configuration',
                        element: <ViewContentConfiguration />
                    },
                    {
                        path: 'content-preview',
                        element: <ContentPreview />
                    },
                    {
                        path: 'descriptive-content-preview',
                        element: <DescriptiveContentPreview />
                    },
                    // {
                    //     path: 'feedback-preview',
                    //     element: <FeedbackPreview />
                    // },
                ],
            },
            {
                path: 'enable-exam',
                element: <ContentAdminGuard component={<EnableExam />} />
            },
            {
                path: 'score-management',
                element: <BackOfficeAuthGuard component={<ScoreManagement />} />
            },
            {
                path: 'customer',
                children: [
                    {
                        path: '',
                        element: <Navigate to='dashboard' />
                    },
                    {
                        path: 'dashboard',
                        // element: <CustomerAuthGuard component={<CustomerDashboard />} />
                        element: <CustomerAuthGuard component={<Dashboard />} />
                    },
                    {
                        path: 'chart',
                        element: <CustomerChart />
                    },
                    {
                        path: 'mock-exam',
                        element: <CustomerMockExam />
                    },
                    {
                        path: 'live-exam',
                        element: <CustomerLiveExam />
                    }
                ]
            },
        ]
    }
];
